import { RefObject, useMemo, useState } from "react";
import { usePortfolioTableQuery } from "src/api/client/portfolio/portfolio-table.api";
import { useIsSectionInView } from "src/components-mui/common/jump-marks/use-is-section-in-view";
import { PORTFOLIO_TABLE_DEFAULT_SORTING } from "src/components-mui/pages/detail/portfolio-table-section/portfolio-table-constants";
import { getNextSortDirection } from "src/components-mui/pages/detail/portfolio-table-section/portfolio-table-sorting";
import {
    sortPortfolioTableDataByColumn,
    Sorting,
    sortPortfolioTableDataGroups,
} from "src/components-mui/pages/detail/portfolio-table-section/sort-utils";

export const usePortfolioTable = (fullName: string, sectionRef: RefObject<HTMLDivElement>) => {
    const isVisible = useIsSectionInView({ sectionRef, threshold: 0.1, visibleOnce: true });

    const { data: rawData, isLoading, isError } = usePortfolioTableQuery(fullName, { enabled: isVisible });
    const [sorting, setSorting] = useState<Sorting>(PORTFOLIO_TABLE_DEFAULT_SORTING);

    const data = useMemo(
        () => (rawData ? sortPortfolioTableDataByColumn(sortPortfolioTableDataGroups(rawData), sorting) : undefined),
        [rawData, sorting]
    );

    const onSort = (column: Sorting["column"]) => {
        setSorting(previousSorting => ({
            column,
            direction: getNextSortDirection(previousSorting.column === column, previousSorting.direction),
        }));
    };

    return { isLoading, isError, data, sorting, onSort };
};
